<template>
  <div class="index">
    <van-nav-bar left-text="返回" left-arrow @click-left="back" />
    <div v-if="first == 1">
      <div class="header-tool">
        <h3 class="title">共{{ count }}个客户</h3>
        <span
          @click="toggleAll"
          v-if="result.length == customerList.length"
          class="clickable select-all"
          >取消</span
        >
        <span v-else @click="checkAll" class="clickable select-all">全选</span>
      </div>
      <div class="content" style="padding-bottom: 60px">
        <van-checkbox-group
          icon-size="15px"
          v-model="result"
          ref="checkboxGroup"
        >
          <!--        <van-list-->
          <!--            v-model="loading"-->
          <!--            :finished="finished"-->
          <!--            finished-text="没有更多了"-->
          <!--            @load="onLoad"-->
          <!--        >-->
          <div
            class="user-list"
            style=""
            v-for="(item, index) in customerList"
            :key="index"
          >
            <p class="time">{{ item.createTime }}</p>
            <div
              class="user-item"
              :class="{ 'border-color': result.indexOf(item) >= 0 }"
            >
              <div class="top-wrapper">
                <img class="avatar clickable" :src="item.avatar" />
                <span class="name">{{ item.name }}</span>
                <van-checkbox
                  @click="ac"
                  style="position: absolute; right: 15px; top: 15px"
                  :name="item"
                >
                </van-checkbox>
              </div>
              <div class="bottom">
                <div :class="{ unset: item.zk }" class="bottom-list">
                  <div v-for="(i, is) in item.tags" :key="is">{{ i }}</div>
                </div>
                <div
                  class="button"
                  v-if="item.aa.join('').length > 18"
                  style="padding: 0 12px"
                >
                  <div v-if="!item.zk" @click="item.zk = true">
                    展开
                    <van-icon name="arrow-down" />
                  </div>
                  <div v-else @click="item.zk = false">
                    收起
                    <van-icon name="arrow-up" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--        </van-list>-->
        </van-checkbox-group>
      </div>

      <van-button
        :disabled="result.length < 1"
        class="nexts"
        @click="nextF"
        block
        type="info"
        >下一步</van-button
      >
    </div>
    <div v-else-if="first == 2">
      <div class="header-tool">
        <h3 class="title">批量设置群聊名称</h3>
      </div>
      <van-cell-group>
        <van-field
          v-model="groupName"
          label="群名称"
          placeholder="请输入群名称"
        />
        <van-cell
          title="群序号"
          value="内容"
          label="群聊名称将按照序号依次创建"
        >
          <van-stepper v-model="groupNum" />
        </van-cell>

        <van-button
          class="nexts"
          :loading="loading"
          @click="pullRoomBtn"
          block
          type="info"
          >开始拉群</van-button
        >
      </van-cell-group>
    </div>
    <div v-else-if="first == 3">
      <div class="ch_la">一键拉群</div>
      <div class="c_header">
        <van-notice-bar
          style="font-size: 12px; margin-bottom: 10px"
          wrapable
          :scrollable="false"
          text=""
        >
          <div class="ch_txt">
            <img src="../../assets/images/tips.png" alt="">
            <div>
              必看:拉群结束前请不要关闭此窗口，首次使用前请查看一键拉群教程
            </div>
          </div>
        </van-notice-bar>
      </div>
      <div class="content">
        <div class="c_header1">
          <div class="hdes">
            <div class="hdes_title">
              <img src="../../assets/images/huanyingyu.png" alt="">
              注意事项：
            </div>
            <div>
              1、将为选择的{{ result.length }}个客户一键拉{{
                groupList.length
              }}个群聊，因企业微信限制，一键拉群每个群内最多只可选择39位客户
            </div>
            <div>2、点击【一键拉群】就可以一键创建群聊哦~</div>
          </div>
        </div>
        <div class="c_list">
          <div class="c_item" v-for="(item, index) in groupList" :key="index">
            <div class="ci_top">
              <div class="cit_left">
                <img class="citl_img" src="../../assets/qunliao.png" alt="" />
              </div>
              <div class="cit_right">
                <div class="citr_name">{{ item.groupName }}</div>
                <div class="citr_num">群聊人数：{{ item.groupNum }}</div>
              </div>
            </div>
            <div class="ci_btns" :class="{ gray: item.isClick }">
              <div class="ci_btn cib_c2" @click="editGroupNameClik(item)">
                修改群名称
              </div>
              <div class="ci_btn cib_c1" v-if="item.isClick">已成功拉群</div>
              <div class="ci_btn cib_c1" @click="pullGroup(item)" v-else>
                一键拉群
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <editGroupName
      v-show="false"
      ref="groupName"
      :item="curItem"
    ></editGroupName>
  </div>
</template>

<script>
import { filterContact } from "../../api/roomTemplate";
import { openEnterpriseChat } from "../../utils/wxCodeAuth";
import { userCenter } from "../../api/homePage";
import editGroupName from "../../components/edit/groupName/popup.vue";

export default {
  components: {
    editGroupName,
  },
  data() {
    return {
      // 條件數據
      customerList: [],
      result: [],
      allChose: false,
      borderColor: {
        border: "1px solid #1890ff;",
      },
      serchData: null,
      count: 0,
      first: 1,
      groupName: "",
      groupNum: 0,
      loading: false,
      groupList: [],
      curItem: {},
    };
  },
  watch: {},
  methods: {
    // 客戶選擇
    ac() {},
    checkAll() {
      this.$refs.checkboxGroup.toggleAll(true);
    },
    toggleAll() {
      this.$refs.checkboxGroup.toggleAll();
    },
    editGroupNameClik(item) {
      this.curItem = item;
      this.$refs.groupName.show(item.groupName);
    },
    async pullGroup(item) {
      item.isClick = true;
      this.loading = true;
      try{
        console.log("拉群数据====",item.externalUserIds)
      console.log("拉群长度====",item.externalUserIds.split(";").length)
      }catch(e){

      }
      
      await openEnterpriseChat(
        item.wxUserId,
        item.externalUserIds,
        item.groupName,
        ""
      );
      this.loading = false;
    },
    async pullRoomBtn() {
      if (!this.groupName) {
        this.$message.error("请输入群名称");
        return;
      }
      let res = await userCenter();
      let baseInfo = res.data.baseInfo;
      let maxNum = 39; //每个群最多人数 不大于39人
      if (this.result.length <= maxNum) {
        let externalUserIds = this.result
          .map((i) => {
            return i.wxExternalUserid;
          })
          .join(";");
        this.loading = true;
        await openEnterpriseChat(
          baseInfo.wxUserId,
          externalUserIds,
          this.groupName,
          ""
        );
        this.loading = false;
        this.$router.push("/tool/index");
      } else {
        this.first = 3;
        //大于39了。就拆分多个群组 每个搞成39人。
        let groupNum = Math.ceil(this.result.length / maxNum);
        let rnum = this.result.length % maxNum;
        this.groupList = [];
        for (let i = 0; i < groupNum; i++) {
          let group = {
            id: i,
            groupName: this.groupName + "-" + (this.groupNum + i),
            groupNum: maxNum + 1,
            externalUserIds: [],
            wxUserId: baseInfo.wxUserId,
            isClick: false,
          };
          if (i == groupNum - 1) {
            group.groupNum = rnum + 1;
          }
          let groupIds = [];
          for (let j = 0; j < maxNum; j++) {
            let index = i * maxNum + j;
            if (index >= this.result.length) {
              break;
            }
            groupIds.push(this.result[index].wxExternalUserid);
          }
          group.externalUserIds = groupIds.join(";");
          this.groupList.push(group);
        }

        console.log("groupList===", this.groupList);
      }
    },
    nextF() {
      this.first = 2;
    },
    back() {
      this.$router.back();
    },

    getData() {
      filterContact(this.serchData).then((res) => {
        this.count = res.data.count;
        res.data.list.forEach((i) => {
          i.zk = false;
          i.aa = i.tags;
        });
        this.customerList = res.data.list;
      });
    },
  },
  created() {
    if (this.$route.query.tags) {
      // tags: 企业标签：
      //     startTime: 添加时间：,
      //     endTime: this.endTime,
      //     addWay: 添加渠道：,
      //     gender: 客户性别：
      this.serchData = this.$route.query;
      this.getData();
    }
  },
};
</script>

<style lang="less" scoped>
/deep/.van-nav-bar__content {
  background: #2b63cd;
  color: #fff;
}
/deep/.van-nav-bar .van-icon {
  color: #fff;
}
/deep/.van-nav-bar__text {
  color: #fff;
}
/deep/.van-nav-bar__title {
  color: #fff;
}
/deep/ .van-tabs__line {
  bottom: 9px;
  margin-top: 0;
}

/deep/ .van-tabs__nav--line {
  padding-bottom: 1px;
}

/deep/ .van-tab__text {
  margin-bottom: 10px;
}

/deep/ .van-tab {
  background: #ffffff;
}

/deep/ .van-tabs__nav {
  background: #f1f2f5;
}

/deep/ .van-empty__image img {
  object-fit: contain;
}

/deep/ .van-dropdown-menu__bar {
  height: 36px;
}

/deep/ .van-ellipsis {
  font-size: 13px;
}

/deep/ .van-action-sheet__description {
  font-size: 16px;
  color: #444;
}

/deep/ .tabs .van-cell__title {
  width: 56px !important;
  flex: none !important;
  white-space: nowrap;
}

.index {
  font-size: 14px;
  height: 100%;
  background: #f2f4f8;

  p {
    margin: 0 !important;
  }

  .fs17 {
    font-size: 15px;
  }

  .fs13 {
    font-size: 12px;
  }

  .fs14 {
    font-size: 14px;
  }

  .header-tool {
    padding: 0 18.2347px;
    height: 40px;
    display: flex;
    -webkit-box-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    align-items: center;
    background-color: #fff;
    .clickable {
      font-size: 12px;
    }
    .title {
      font-size: 14px;
      margin: 0 !important;
    }

    .select-all {
      font-size: 12px;
      color: #1890ff;
    }
  }

  .bottom {
    .bottom-list {
      background: #fff;
      padding: 0 5px;
      font-size: 12px;
      max-height: 30px;
      overflow: hidden;
      padding-bottom: 10px;

      div {
        background: #f7f7f7;
        border: 1px solid #e9e9e9;
        display: inline-block;
        padding: 2px 3px;
        border-radius: 6px;
        margin: 0px 5px;
        margin-bottom: 7px;
      }
    }

    .button {
      padding: 0px 12px;
      background: #fff;
      padding-bottom: 5px !important;

      div {
        font-size: 13px;
        color: #8db1db;
      }
    }

    .unset {
      max-height: unset;
    }
  }

  .border-color {
    border: 1px solid #1890ff !important;
  }

  .nexts {
    position: fixed;
    left: 0;
    bottom: 10px;
    width: 90%;
    /* width: auto; */
    /* margin: 0 auto; */
    left: 50%;
    transform: translate(-50%);
  }

  .ch_la {
    padding: 10px 0;
    text-align: center;
    background: #ffffff;
    font-size: 20px;
    color: #333;
    font-weight: bold;
  }
  .c_header {
    background: #ffffff;
    padding: 10px 20px;
    .ch_txt {
      display: flex;
      font-size: 14px;
      align-items: center;
      img{
        width: 40px;
        height: 30px;
      }
    }

    /deep/ .van-notice-bar {
      border-radius: 10px;
    }
  }
  .content {
    background: #f2f4f8;
    min-height: 92%;
    //padding-top: 5px;
    padding: 16.668px 16.668px 0;
    .c_header1 {
      background: #ffffff;
      padding: 20px;
      .hdes {
        padding: 12.5px;
        background: #f7fbff;
        border: 1px solid #cce9ff;
        font-size: 12.5px;
        color: #333;
        .hdes_title {
          font-size: 16px;
          font-weight: bold;
          padding-bottom: 5px;
          img{
            width: 13px;
            height: 13px;
          }
        }
      }
    }

    .c_list {
      padding-bottom: 30px;
      margin-top: 10px;
      .c_item {
        background: #ffffff;
        padding: 10px 5px;
        margin-bottom: 20px;
        .ci_top {
          padding-bottom: 10px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .cit_left {
            .citl_img {
              width: 66.1007px;
              height: 66.1007px;
              border-radius: 4.5587px;
              margin-right: 13.676px;
              cursor: pointer;
            }
          }
          .cit_right {
            .citr_name {
              font-size: 14px;
              font-weight: 600;
              margin-bottom: 5px;
            }
            .citr_num {
              font-size: 12px;
              color: #888;
            }
          }
        }
        .gray {
          // filter: grayscale(1);
          pointer-events: none; /* 可选：禁用点击 */
          opacity: 0.6;
        }
        .ci_btns {
          padding-top: 10px;
          border-top: 1px #ccc solid;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          .ci_btn {
            padding: 10px 20px;

            background: #f7fbff;
            border: 1px solid #73c4f6;
            font-size: 12.5px;
            color: #333;
            border-radius: 4px;
            cursor: pointer;
            margin-right: 10px;
            border-radius: 20px;
          }
          .cib_c1 {
            color: #1890ff !important;
          }
          .cib_c2 {
            border: 1px solid #cccccc !important;
          }
        }
      }
    }
    .hint {
      margin-top: 12px !important;
      padding: 12.5px;
      background: #f7fbff;
      border: 1px solid #cce9ff;
      font-size: 12.5px;
      color: #333;
    }

    .button-bottom {
      display: flex;
      align-items: center;
      justify-content: space-between;
      /* margin-top: 50px; */
      position: fixed;
      bottom: 10px;
      width: 100%;
      left: 0;
      padding: 0 10px;
    }

    img {
      width: 22px;
      height: 22px;
    }

    .time {
      margin-bottom: 9.676px !important;
    }

    .user-item {
      background: #fff;
      border-radius: 6px;
      border: 1px solid transparent;
      position: relative;
      padding: 18.2347px 0px 0;
      margin-bottom: 13.676px;
      position: relative;
      padding-bottom: 7px;

      .top-wrapper {
        padding: 0 18.2347px;
        padding-bottom: 18.2347px;
        display: flex;
        -webkit-box-align: center;
        align-items: center;

        .avatar {
          width: 66.1007px;
          height: 66.1007px;
          border-radius: 4.5587px;
          margin-right: 13.676px;
          cursor: pointer;
        }

        .name {
          color: rgba(0, 0, 0, 0.85);
          font-weight: 600;
          align-self: flex-start;
        }
      }
    }
  }
}
</style>
